/**
 * A small in-memory ring of the browser's most recent API calls: a client-made request id
 * and the API error code. Nothing else is kept (no status, URL, header or body), so attaching it to a
 * problem report, only when the customer opts in, reveals no project content or secret.
 */
export type ActivityEntry = { request_id: string; error_code: string };

const MAX_ENTRIES = 20;
const entries: ActivityEntry[] = [];
let counter = 0;

export function nextClientRequestId(): string {
  counter += 1;
  const random = Math.random().toString(36).slice(2, 8);
  return `c-${Date.now().toString(36)}-${counter}-${random}`;
}

export function recordActivity(requestId: string, errorCode = ''): void {
  const code = /^[a-z0-9_.-]{0,64}$/.test(errorCode) ? errorCode : '';
  entries.push({ request_id: requestId, error_code: code });
  if (entries.length > MAX_ENTRIES) entries.splice(0, entries.length - MAX_ENTRIES);
}

export function recentActivity(): ActivityEntry[] {
  return entries.map((entry) => ({ ...entry }));
}

export function clearActivityForTests(): void {
  entries.length = 0;
}
